import Axios from 'axios'
import baseUrl from '../utils/setting'
import { Message } from 'element-ui'
import qs from 'qs'
import router from '@/router/index'
import ssUtil from '@/utils/SStorage'

function Service(){
  let axiosIns = Axios.create({
    baseURL: baseUrl,
    withCredentials: true,
    transformRequest: [data => qs.stringify(data)],
    paramsSerializer: function(params) {
      return qs.stringify(params, {arrayFormat: 'brackets'})
    }
  })

  axiosIns.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8'

  // request拦截器
  axiosIns.interceptors.request.use(
    config => {
      const authToken = sessionStorage.getItem('authToken')
			if(config.method=='post'){
				config.data = {
					...config.data,
          'Authorization': authToken,
          'timestamp':new Date().getTime(),
				}
			}else if(config.method=='get'){
				config.params = {
          ...config.params,
          'Authorization': authToken,
          'timestamp':new Date().getTime(),
        }
			}
      return config
    },
    error => {
      // Do something with request error
      console.log(error) // for debug
      Promise.reject(error)
    }
  )

  // response 拦截器
  axiosIns.interceptors.response.use(
    response => {
      /**
       * 根据retCode 做处理
       */
      const res = response.data
      if (res.retCode !== '000') {
        // 001 :需要重新登录
        if (res.retCode == '001') {
            ssUtil.clear()
            router.push('/login')
        }
        return Promise.reject(res.retMsg)
      } else {
        return response
      }
    },
    error => {
      console.log('err' + error) // for debug
      Message({
        message: error.message,
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(error)
    }
  )

  this.post = (url, kwargs) => {
		return axiosIns.post(url, kwargs)
  }

	this.get = (url, kwargs) => {
    return axiosIns.get(url, {params: kwargs})
	}

	// ==================登录模块======================================
    //  登录
    this.login = (params) => {
        return this.post('/user/login',params)
    }
    //  退出登录
    this.logout = () => {
        return this.get('/user/logout')
    }
    //  更新用户信息
    this.updateUserInfo = (params) => {
        return this.post('/user/updateUserInfo',params)
    }
    //  添加我的收藏
    this.addMyFavoriteItem = (params) => {
        return this.post('/user/addMyFavorite',params)
    }
    //  查询我的收藏
    this.queryMyFavorites = () => {
      return this.get('/user/queryMyFavorites')
    }
    //  删除我的收藏
    this.removeMyFavorite = (params) => {
      return this.post('/user/removeMyFavorite',params)
    }
	// ====================产品模块==================================
    //  查询产品异动
    this.getSingularProduct = () => {
        return this.get('/product/getSingularProduct')
    }
    //  更新产品异动
    this.getProductRemind = (params) => {
        return this.get('/product/getProductRemind',params)
    }
	//  产品搜索
    this.productSearch = (params) => {
        return this.get('/product/search',params)
	}
	//  查询产品产业链
    this.getProductChain = (params) => {
        return this.get('/product/getProductChain',params)
	}
	//  查询产品数据
    this.getProductData = (params) => {
        return this.get('/product/getProductData',params)
	}
	//  查询产品指标
    this.getProductSeries = (params) => {
        return this.get('/product/getProductSeries',params)
	}
	//  查询产品指标数据
    this.getProductSeriesData = (params) => {
        return this.get('/product/getProductSeriesData',params)
    }

    //  查询生产公司
    this.getCompanysByProduct = (params) => {
        return this.get('/product/getCompanysByProduct',params)
    }
    //  增加详情操作记录
    this.addHistoryOpeParam = (params) => {
        return this.post('/product/addHistoryOpeParam',params)
    }
    //  查询历史操作记录
    this.queryHistoryOpeParam = (params) => {
        return this.get('/product/queryHistoryOpeParam',params)
    }

    //  查询历史操作记录
    this.getCoreProductChain = (params) => {
      return this.get('/product/getCoreProductChain',params)
  }
  //  查询行业产业链列表信息
  this.getCoreNameInfo = () => {
    return this.get('/product/getCoreNameInfo')
  }

	// =====================公司模块==================================
	// 公司搜索
    this.companySearch = (params) => {
        return this.get('/company/search',params)
	}
	//  查询公司展望
    this.getCompanyProspect = () => {
        return this.get('/company/getCompanyProspect')
	}
	//  查询公司核心驱动
    this.getCompanyCoreDrive = (params) => {
        return this.get('/company/getCompanyCoreDrive',params)
	}
	// 查询公司核心驱动指标数据
    this.getCompanyCoreDriveSeriesData = (params) => {
        return this.get('/company/getCompanyCoreDriveSeriesData',params)
	}
	//  查询公司核心产品
    this.getCompanyCoreProduct = (params) => {
        return this.get('/company/getCompanyCoreProduct',params)
	}
	//  查询公司核心产品指标数据
    this.getCompanyCoreProductSeriesData = (params) => {
        return this.get('/company/getCompanyCoreProductSeriesData',params)
	}
	//  查询公司核心概念
    this.getCompanyCoreConcept = (params) => {
        return this.get('/company/getCompanyCoreConcept',params)
	}
	//  查询相关公司
    this.getRelatedCompany = (params) => {
        return this.get('/company/getRelatedCompany',params)
    }
    //  查询概念相关公司
    this.getRelatedCompanyFromConcept = (params) => {
        return this.get('/company/getRelatedCompanyFromConcept',params)
    }
    //  查询公司核心产品签发数据（医药）
    this.getCompanyCoreProductIssueData = (params) => {
      return this.get('/company/getCompanyCoreProductIssueData',params)
  }
}

export default new Service();



// WEBPACK FOOTER //
// ./src/service/api.js